// Dependencies
import { forwardRef } from 'react';
import NextLink from 'next/link';

// Material UI Components
import Box, { BoxProps } from '@mui/material/Box';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { UrlObject } from 'url';
// ----------------------------------------------------------------------

interface Props {
  disabledLink?: boolean;
  boxProps?: BoxProps;
  typographyProps?: TypographyProps;
  hrefOverride?: string | UrlObject;
}

const Logo = forwardRef<any, Props>(
  ({ disabledLink = false, boxProps, typographyProps, hrefOverride }, ref) => {
    const logo = (
      <Box
        {...boxProps}
        ref={ref}
        sx={{ cursor: !disabledLink ? 'pointer' : undefined, ...boxProps?.sx }}
      >
        <Typography variant="h4" fontFamily="raleway" color={'inherit'} {...typographyProps}>
          Jsur Capital
        </Typography>
      </Box>
    );

    if (disabledLink) {
      return <>{logo}</>;
    }

    return (
      <NextLink passHref href={hrefOverride || '/'}>
        {logo}
      </NextLink>
    );
  }
);

export default Logo;
